/* eslint-disable */
import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { CgSpinner } from 'react-icons/cg';

import * as c from './constants';

function Radio(props) {
  const { value, disabled, type, onSetFieldValue, onChange, name, isLoading } =
    props || {};

  const style = {
    ...c.dispatchClassName({ value, disabled, type }),
  };

  const handleOnChange = () => {
    if (disabled) return;

    if (typeof onSetFieldValue === 'function') {
      onSetFieldValue(name, !value, { row: props });
      return;
    }

    if (typeof onChange === 'function') {
      onChange(
        (prev) => ({
          ...prev,
          [name]: !value,
        }),
        { row: props }
      );
    }
  };

  if (isLoading) {
    return (
      <CgSpinner className="h-[19px] w-[19px] animate-spin -m-0.5 -ml-px" />
    );
  }

  return (
    <div
      className={cn(
        'h-4 w-4 rounded-full border relative',
        style.background,
        style.border,
        disabled ? 'cursor-not-allowed' : 'cursor-pointer'
      )}
      onClick={handleOnChange}
      role="presentation"
    >
      {Boolean(value) && !disabled && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white h-[7.11px] w-[7.11px] rounded-full" />
      )}
    </div>
  );
}

Radio.defaultProps = {
  value: false,
  disabled: false,
  isLoading: false,
  type: 'secondary',
  onChange: false,
  onSetFieldValue: false,
  name: '',
};

Radio.propTypes = {
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  type: PropTypes.oneOf(c.TYPE),
  name: PropTypes.string,
  onSetFieldValue: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Object),
  ]),
  onChange: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Object)]),
};

export default Radio;
